/**
 * Account Form Trigger
 * Handles clicking the "Use Existing Account" button to open the account form
 * Only runs on the create-fundraiser page
 */

document.addEventListener('DOMContentLoaded', () => {

    document.addEventListener("click", (event) => {
        const target = event.target as HTMLElement;

        if (target && target.classList.contains("js-trigger-account-form")) {
            event.preventDefault();
            
            const headerAccountButton = document.querySelector('.js-slide-control[data-slide-target="account-form"]') as HTMLElement;
            
            if (headerAccountButton) {
                headerAccountButton.click();
            }
        }
    });
    
});

